var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

export default function trackPresentationVersion(version, _ref) {
  var entities = _ref.entities,
      props = _objectWithoutProperties(_ref, ["entities"]);

  return _extends({
    entities: _extends({}, entities, {
      schemaVersions: Object.keys(entities).reduce(function (acc, next) {
        return Object.keys(entities[next]).reduce(function (innerAcc, nextKey) {
          innerAcc[nextKey] = version;
          return innerAcc;
        }, acc);
      }, {})
    })
  }, props);
}